var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useStylesHook } from "../hooks/useStylesHook";
import { hexToRGB, tone } from "../theming/colors";
import { Client } from "../theming/ThemeProvider";
import { PORTAL_THEME, TMS_THEME } from "../theming/theming";
import { useThemeContext } from "../theming/useThemeContext";
export function useButtonClasses(type, block) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    var _r = useThemeContext(), client = _r.client, buttonStyles = _r.buttonStyles;
    var button = {};
    if (client === Client.Portal) {
        button = __assign(__assign({}, button), { padding: [5, 10], fontWeight: PORTAL_THEME.typography.strong.fontWeight, borderColor: "rgba(0,0,0,0)", fontSize: PORTAL_THEME.typography.strong.fontSize, "&:hover:enabled": {
                color: PORTAL_THEME.palette.primary.base.color,
                backgroundColor: PORTAL_THEME.palette.gray.fog.color,
                borderColor: "rgba(0,0,0,0)",
                borderRadius: "".concat((_b = (_a = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.default) === null || _a === void 0 ? void 0 : _a.borderRadius) !== null && _b !== void 0 ? _b : TMS_THEME.root.borderRadius),
                textDecoration: "none",
            }, "&:hover": {
                color: PORTAL_THEME.palette.primary.base.color,
                backgroundColor: PORTAL_THEME.palette.gray.fog.color,
                borderColor: "rgba(0,0,0,0)",
                borderRadius: "".concat((_d = (_c = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.default) === null || _c === void 0 ? void 0 : _c.borderRadius) !== null && _d !== void 0 ? _d : TMS_THEME.root.borderRadius),
                textDecoration: "none",
            }, "&:focus:active:enabled": {
                color: PORTAL_THEME.palette.primary.base.color,
                backgroundColor: PORTAL_THEME.palette.gray.fog.color,
                borderColor: "rgba(0,0,0,0)",
            }, "&:focus": {
                color: PORTAL_THEME.palette.primary.base.color,
                backgroundColor: PORTAL_THEME.palette.gray.fog.color,
                borderColor: "rgba(0,0,0,0)",
                textDecoration: "none",
            }, "&[disabled]:hover": {
                borderColor: "rgba(0,0,0,0)",
            }, borderRadius: (_f = (_e = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.default) === null || _e === void 0 ? void 0 : _e.borderRadius) !== null && _f !== void 0 ? _f : TMS_THEME.root.borderRadius, color: PORTAL_THEME.palette.primary.base.color, backgroundColor: PORTAL_THEME.palette.gray.white.color });
        if (type === "primary") {
            var alternateState = {
                color: (_g = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) === null || _g === void 0 ? void 0 : _g.color,
                backgroundColor: tone((_j = (_h = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) === null || _h === void 0 ? void 0 : _h.backgroundColor) !== null && _j !== void 0 ? _j : "", -15),
                borderColor: "rgba(0,0,0,0)",
                textDecoration: "none",
                borderRadius: (_l = (_k = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) === null || _k === void 0 ? void 0 : _k.borderRadius) !== null && _l !== void 0 ? _l : TMS_THEME.root.borderRadius,
            };
            button = __assign(__assign({}, button), { boxShadow: BUTTON_BOX_SHADOW, color: (_m = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) === null || _m === void 0 ? void 0 : _m.color, backgroundColor: (_o = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) === null || _o === void 0 ? void 0 : _o.backgroundColor, "&:hover:enabled": alternateState, "&:hover": alternateState, "&:focus:active:enabled": alternateState, "&:focus:enabled": alternateState, "&:focus": alternateState, "&:active:enabled": alternateState, "&[disabled]:hover": {
                    color: (_p = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) === null || _p === void 0 ? void 0 : _p.color,
                    backgroundColor: (_q = buttonStyles === null || buttonStyles === void 0 ? void 0 : buttonStyles.primary) === null || _q === void 0 ? void 0 : _q.backgroundColor,
                }, textDecoration: "none" });
        }
        if (type === "default") {
            button = __assign(__assign({}, button), { boxShadow: "0px 2px 4px rgba(".concat(hexToRGB(PORTAL_THEME.palette.gray.slate.color), ", 0.2)") });
        }
        if (type === "suppressed") {
            button = __assign(__assign({}, button), { color: PORTAL_THEME.palette.primary.base.color, backgroundColor: "transparent", padding: [5, 0] });
        }
    }
    if (block) {
        button = __assign(__assign({}, button), { display: "block", width: "100%" });
    }
    return useStylesHook({ button: button, baseButton: BASE_BUTTON });
}
export var BUTTON_OUTLINE = {
    outlineWidth: 2,
    outlineStyle: "auto",
    outlineColor: "#cbe1f7",
    outlineOffset: 0,
};
export var BASE_BUTTON = {
    display: "inline-block",
    marginBottom: 0,
    textAlign: "center",
    cursor: "pointer",
    fontWeight: 500,
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    touchAction: "manipulation",
    backgroundImage: "none",
    lineHeight: 1.42857,
    userSelect: "none",
    "-webkit-appearance": "button",
    "&:focus:enabled": BUTTON_OUTLINE,
    "&:focus": BUTTON_OUTLINE,
    "&:focus:active": BUTTON_OUTLINE,
    "&:active": BUTTON_OUTLINE,
};
export var BUTTON_BOX_SHADOW = "0px 2px 4px rgba(".concat(hexToRGB(PORTAL_THEME.palette.gray.slate.color), ", 0.2)");
